import { REDUCER_NAME } from './const'
import { selectIsFetching as selectIsDetailFetching } from './detail/selector'
import { selectIsFetching as selectIsSearchFetching } from './search/selector'


export const selectOwnState = state => {
    return state[REDUCER_NAME]
}

export const selectIsFetchingAppointment = (state) => {
    return selectIsDetailFetching(state) || selectIsSearchFetching(state)
}



// WEBPACK FOOTER //
// ./src/modules/appointment/state/selector.js